import React from 'react'
import { ArchivoComponent } from './ArchivoComponent'
import { useSelector } from 'react-redux'
import estilos from './ArchivoComponent.module.css'

const ArchivosPrediosViveros = (props) => {

    const {tabla, id, api, tipo, idAnexoFK = undefined, filesMap = undefined, opcionSelect = undefined} = props
    const {handdleFile, handdleRemovePrev, files} = api
    const anexoInfo = props.anexo
    const name = props.name
    const [opcionTipoArchivo, setOpcionTipoArchivo] = React.useState("")
    const {handleChangeOptionFile, handdleRemoveOptionFile, deletePrevFile, opcion} = opcionSelect
    const modoCorreccion = useSelector(store => store.FC_01Solicitud.modoCorreccion)

    const changeOption = (value) => {
        if(value !== "" && opcionTipoArchivo === ""){
            handleChangeOptionFile({ id: id, opcionFile: value, idAnexoFK: idAnexoFK })
        }else if(value !== "" && opcionTipoArchivo !== ''){
            deletePrevFile(files, id)
            handdleRemoveOptionFile({ id: id, opcionFile: value, idAnexoFK: idAnexoFK})
        }
    }
    const handleSetOptionLocalFromParent = () => {
        opcion.map((field, index) => {
            if(field.id + '' === id + ''){
                setOpcionTipoArchivo(field.opcionFile)
            }
        })
    }
    React.useEffect(() => {
        handleSetOptionLocalFromParent()
    }, [opcionSelect])
    
    return (
        <div className={`col-md-12 mb-3 `}>
            <div className='row'>
                <div className='col-md-4'>
                    <label className="text-center textoParaArchivos"><strong>{name}: {anexoInfo.nombreparaje}</strong></label><br/>
                </div>
                <div className={`col-md-8 ${estilos.selectorFile}`}>
                    <div className="form-floating mb-2">
                        <select className={`form-select form-select-sm`} value={opcionTipoArchivo} onChange={e => changeOption(e.target.value)} disabled={modoCorreccion && filesMap?.[0] !== undefined}>
                            <option value="">Seleccione una opción</option>
                            <option value="copiaescritura">Copia de escritura</option>
                            <option value="constanciaposesion">Constancia de posesión</option>
                            <option value="contratoarrendamiento">Contrato de arrendamiento</option>
                            <option value="contratocompraventa">Contrato de compraventa</option>
                            <option value="contratocomodato">Contrato de comodato</option>
                        </select>
                    </div>
                </div>
            </div>
            {
                opcionTipoArchivo === 'copiaescritura' ? 
                <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`COPIAESC${id}`} tabla={tabla} textLabel="Copia de escritura" tipo={tipo} idAnexoFK={idAnexoFK} filesMap={filesMap}/> : 
                opcionTipoArchivo === 'constanciaposesion' ? 
                <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CONSPOS${id}`}tabla={tabla} textLabel="Constancia de posesión" tipo={tipo} idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                : 
                opcionTipoArchivo === 'contratoarrendamiento' ?
                <div>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CONARREN${id}`} tabla={tabla} textLabel="Contrato de arrendamiento" tipo={tipo} idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`IOVARREN${id}`} tabla={tabla} textLabel="Identificación oficial vigente del arrendador" tipo={tipo} idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`IOVCOMPR${id}`} tabla={tabla} textLabel="Identificación oficial vigente del arrendatario" tipo={tipo} idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                    <hr/>
                </div> : 
                opcionTipoArchivo === 'contratocompraventa' ? 
                <div>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CONCOMPR${id}`} tabla={tabla} textLabel="Contrato de compraventa" tipo={tipo} idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`IOVARREN${id}`} tabla={tabla} textLabel="Identificación oficial vigente del vendedor" tipo={tipo} idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`IOVCOMPR${id}`} tabla={tabla} textLabel="Identificación oficial vigente del comprador" tipo={tipo} idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                    <hr/>
                </div> : 
                opcionTipoArchivo === 'contratocomodato' ? 
                <div>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CONCOMODA${id}`} tabla={tabla} textLabel="Contrato de comodato" tipo={tipo} idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`IOVCOMTE${id}`} tabla={tabla} textLabel="Identificación oficial vigente del comodante" tipo={tipo} idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`IOVCOMRIO${id}`} tabla={tabla} textLabel="Identificación oficial vigente del comodatario" tipo={tipo} idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                    <hr/>
                </div> : ('')
            }
        </div>
    )
}

export default ArchivosPrediosViveros